/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IProductListBlockViewProps } from './product-list-block';

const ProductListBlockView:React.FC<IProductListBlockViewProps>=(props)=>{
    const{
        productBlockContainer,
        imageContainer,
        detailsContainer,
        productImage,
        productName,
        productLink
    } = props;
    return(
        <Module {...productBlockContainer}>
            <div className="product-list-block__image-container">
                <a href={productLink.linkUrl.destinationUrl} aria-label={productLink.ariaLabel} target={productLink.openInNewTab?'_blank':undefined}>
                    <Node {...imageContainer}>{productImage}</Node>
                </a>
            </div>
            <a className="product-list-block__a" href={productLink.linkUrl.destinationUrl} aria-label={productLink.ariaLabel} target={productLink.openInNewTab?'_blank':undefined}>
                <Node {...detailsContainer}>
                    {productName}
                </Node>
            </a>
        </Module>

    );
};

export default ProductListBlockView;
